document.addEventListener("DOMContentLoaded", () => {
  const videoBannerContainer = document.querySelector(
    ".c-hp-video-banner-container"
  );
  const isCampaignEnabled = videoBannerContainer.dataset.enableCampaignUsa;
  const videoElement = document.querySelector(".video-banner");
  const { desktopVideo, mobileVideo } = videoBannerContainer.dataset;
  const playVideoAfterInteraction = () => {
    if (window.innerWidth > 768) {
      videoElement.src = desktopVideo;
    } else {
      videoElement.src = mobileVideo;
    }

    videoElement.load();
    videoElement.play();

    document.removeEventListener("click", playVideoAfterInteraction);
    document.removeEventListener("keypress", playVideoAfterInteraction);
    document.removeEventListener("touchstart", playVideoAfterInteraction);
    document.removeEventListener("scroll", playVideoAfterInteraction);
  };

  document.addEventListener("click", playVideoAfterInteraction);
  document.addEventListener("keypress", playVideoAfterInteraction);
  document.addEventListener("touchstart", playVideoAfterInteraction);
  document.addEventListener("scroll", playVideoAfterInteraction);

  videoElement.addEventListener("load", () => {
    document.querySelectorAll(".c-hp-video-banner-poster")?.forEach((item) => {
      item.remove();
    });
  });
  videoElement.load();

  function customSmoothScroll(x) {
    window.scrollTo({
      top: x,
      behavior: "smooth",
    });
  }

  const xdBannerDropdownOpenId = document.querySelector(
    "#xdBannerDropdownOpenId"
  );
  const customddAndSearchSnippet = document.querySelector(
    "#customddAndSearch-snippet"
  );
  // const shopNowButton = document.querySelector(".shop-now-button");
  function showDD() {
    // const buttonHeight = getComputedStyle(shopNowButton).height;
    // console.log(buttonHeight);
    // shopNowButton.style.visibility = "hidden";
    // shopNowButton.style.pointerEvents = "none";
    customddAndSearchSnippet.style.display = "block";
  }
  function ddActions() {
    // shopNowButton.style.display = "none";
    customddAndSearchSnippet.style.display = "block";

    if (isCampaignEnabled) {
      if (window.innerWidth < 768) customSmoothScroll(855);
    } else {
      if (window.innerWidth < 768) customSmoothScroll(380);
    }
  }

  xdBannerDropdownOpenId.addEventListener("click", ddActions);
  // shopNowButton.addEventListener("click", showDD);
  // -------------------------------
  const hpBannerContentUI = document.querySelector(
    ".c-hp-video-banner-container"
  );
  const buyNowButtonForMobile = document.querySelector(
    ".buyNow-buy-now-mobile"
  );
  const fixedBannerButton = document.querySelector(".fixed-banner-btn");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && window.innerWidth < 768) {
          // Banner görünmüyor ve ekran genişliği 768px'in altında ise
          buyNowButtonForMobile.style.display = "block";
          fixedBannerButton.style.display = "flex";
          // console.log("mobile buy now göster")
        } else {
          // Banner görünüyor veya ekran genişliği 768px'in üstünde ise
          buyNowButtonForMobile.style.display = "none";
          // console.log("mobile buy now gizle")
        }
      });
    },
    { threshold: 0 }
  );

  // Observer'ı banner elementine bağla
  observer.observe(hpBannerContentUI);

  // Pencere boyutu değiştiğinde kontrol et
  window.addEventListener("resize", () => {
    if (!observer) return;
    if (window.innerWidth < 768) {
      observer.observe(hpBannerContentUI);
    } else {
      observer.unobserve(hpBannerContentUI);
      buyNowButtonForMobile.style.display = "none";
    }
  });
  // ---------------------------
  // tavk.to app
  if (window.innerWidth < 1000) styleTawkFunc();

  function styleTawkFunc() {
    const tawkWidgetInterval = setInterval(getTawkWidgetInterval, 1500);
    const clearTawkInterval = setInterval(clearTawkWidgetInterval, 20000);

    function getTawkWidgetInterval() {
      // console.log("tawk func run")
      let tawkWidgetVisibleIframe = document.querySelector(".richpanel-micro");

      if (tawkWidgetVisibleIframe) {
        // console.log("tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide')",tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide'))
        if (!tawkWidgetVisibleIframe.classList.contains("rp-micro-app-hide")) {
          fixedBannerButton.style.justifyContent = "left";
          // document.querySelector(".fixed-banner-btn button").style.width = "70%";
          document.querySelector(".fixed-banner-btn").style.right = "80px";
          document.querySelector(".fixed-banner-btn button").style.fontSize =
            "22px";
          // console.log("tawk render edildi ve interval del");
          clearInterval(tawkWidgetInterval);
        }
      }
    }

    function clearTawkWidgetInterval() {
      clearInterval(tawkWidgetInterval);
      clearInterval(clearTawkInterval);
      // console.log("tawk render edilmedi 10 sn sonra interval del")
    }
  }
});
